/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */


import React, { Fragment } from 'react';
import { ValueData, ValueDataData } from '../../question/questionInterfaces';
import { BaseInputProps } from './InputProps';
import { TableValueDataData } from './table/InputInterface';

interface ChangeProps extends Pick<BaseInputProps, 'valueDataData' | 'handleValueDataChange'> {
  e: React.ChangeEvent<HTMLInputElement>,
  valueDataData: ValueDataData | TableValueDataData
}
const handleChange = ({ e, valueDataData, handleValueDataChange }: ChangeProps) => {
  e.preventDefault();
  const code = e.target.name;
  const value = e.target.value;
  handleValueDataChange({
    ...typeof valueDataData === 'object' ? valueDataData : {},
    [code]: value === '' ? undefined : value,
  });
};
interface TextValueListProps extends Pick<BaseInputProps,
  'isDisabled' | 'index' | 'universalTracker' | 'valueDataData' | 'handleFocus' | 'handleCheckboxChange' | 'handleValueDataChange' | 'displayCheckbox' | 'placeholder'>{
  valueDataData: ValueData['data']
}
export default function TextValueList(props: TextValueListProps) {
  const {
    isDisabled,
    index,
    universalTracker,
    valueDataData,
    handleFocus,
    handleCheckboxChange,
    handleValueDataChange,
    displayCheckbox,
    placeholder
  } = props;

  const valueList = universalTracker.getValueListOptions();
  const valueDataObj = valueDataData ?? {};
  const disabled = isDisabled?.(props);

  return <div className='questionWithFields'>
    {valueList.map((item) => {

      const label = item.name;
      const inputName = item.code;
      const currentValue = valueDataData ? valueDataData[item.code as keyof typeof valueDataData] as string | number | undefined : '';
      const checked = !!displayCheckbox[inputName];
      const checkboxId = `valueCheckbox-${inputName}-${index}-${universalTracker.getId()}`;

      return (
        <Fragment key={inputName}>
          <div className='inputGroupContainer form-check my-2'>
            <input
              type='checkbox'
              id={checkboxId}
              className='form-check-input'
              checked={checked}
              disabled={disabled}
              onChange={(e) => handleCheckboxChange(inputName, e.target.checked)} />
            <label htmlFor={checkboxId} className='strong form-check-label'>{label}</label>
          </div>
          <div className={!checked ? 'd-none mb-3' : ' mb-3'}>
            <div className='input-group mb-3'>
              <input
                type='text'
                autoComplete='off'
                className='styled-input form-control'
                name={inputName}
                defaultValue={currentValue}
                placeholder={placeholder}
                aria-describedby='suffix'
                disabled={disabled}
                required={true}
                onFocus={handleFocus}
                onClick={handleFocus}
                onChange={(e) => handleChange({ e, valueDataData:valueDataObj, handleValueDataChange })} />
            </div>
          </div>
        </Fragment>
      );
    })}
  </div>;
}
